import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6 },
};

const PageLayout = ({ title, subtitle, children }) => (
  <div className="static-page pb-5 bg-background" dir="rtl">
    <section className="bg-primary text-white py-5 mb-5 text-center shadow-lg" style={{ borderRadius: "0 0 40px 40px" }}>
      <div className="container py-4">
        <motion.h1 className="display-4 fw-black" style={{ fontFamily: 'var(--font-headline)' }} {...fadeUp}>{title}</motion.h1>
        {subtitle && (
          <motion.p className="fs-4 arabic-leading mt-3" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}>
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
    <div className="container">
      <div className="bg-white p-4 p-md-5 rounded-celebration shadow-sm border border-primary-dim">
        {children}
      </div>
      <div className="text-center mt-5">
        <Link to="/" className="btn btn-outline-primary px-5 py-3 rounded-pill fw-bold bg-white">الرجوع للرئيسية</Link>
      </div>
    </div>
  </div>
);

export const AfrahPage = () => (
  <PageLayout title="الأفراح (Afrah)" subtitle="كل تفاصيل ليلة العمر في مكان واحد">
    <div className="arabic-leading text-on-surface-variant fs-5">
      <p>الأفراح في يومك هي تجربة استثنائية. بنجمع لك كل الصور اللي ضيوفك بيصوروها في لحظتها، وبنعرضها في ألبوم حي ومباشر على شاشات القاعة.</p>
      <h3 className="fw-black text-primary mt-4 mb-3">ليه تختار يومك لفرحك؟</h3>
      <ul>
        <li>كل الضيوف بيشاركوا في صناعة ذكرياتك.</li>
        <li>مش محتاج تطلب الصور من حد بعد الفرح.</li>
        <li>عرض حي ومباشر للصور على شاشات القاعة.</li>
        <li>ألبوم صور وفيديوهات ورسائل صوتية بجودة عالية.</li>
      </ul>
    </div>
  </PageLayout>
);

export const KhotobaPage = () => (
  <PageLayout title="الخطوبة (Khotoba)" subtitle="سجّل فرحة البدايات بكل تفاصيلها">
    <div className="arabic-leading text-on-surface-variant fs-5">
      <p>يوم الخطوبة هو بداية الرحلة، ومع يومك تقدر توثق كل اللحظات الحلوة دي مع أهلك وأصحابك بشكل عصري وراقي.</p>
      <h3 className="fw-black text-primary mt-4 mb-3">مميزات يومك في الخطوبة:</h3>
      <ul>
        <li>مشاركة سهلة وسريعة عبر الـ QR كود.</li>
        <li>ألبوم خاص بيجمع كل صور اليوم من موبايلات كل اللي حضروا.</li>
        <li>رسائل صوتية بتهنئة حقيقية من القلب.</li>
      </ul>
    </div>
  </PageLayout>
);

export const KatbKetabPage = () => (
  <PageLayout title="كتب الكتاب" subtitle="وثّق اللحظات الرسمية والمشاعر الصادقة">
    <div className="arabic-leading text-on-surface-variant fs-5">
      <p>كتب الكتاب لحظة فارقة، ومع يومك تقدر تجمع كل الصور والمباركات في ألبوم واحد يفضل ذكرى طول العمر.</p>
      <h3 className="fw-black text-primary mt-4 mb-3">يومك مع يومك في كتب الكتاب:</h3>
      <ul>
        <li>توثيق اللحظات الرسمية والاحتفالات العائلية.</li>
        <li>جمع الصور من كل الزوايا ومن كل الضيوف.</li>
        <li>سهولة الوصول للألبوم ومشاركته مع اللي محضرش.</li>
      </ul>
    </div>
  </PageLayout>
);

export const GraduationPage = () => (
  <PageLayout title="حفلات التخرج" subtitle="فرحة النجاح مع أصحابك في ألبوم واحد">
    <div className="arabic-leading text-on-surface-variant fs-5">
      <p>حفلة التخرج هي ختام مرحلة وبداية تانية، جمع كل صورك مع أصحابك ودفعتك في ألبوم واحد كبير بجودة أصلية.</p>
      <h3 className="fw-black text-primary mt-4 mb-3">يومك في حفلات التخرج:</h3>
      <ul>
        <li>ألبوم صور جماعي لكل الدفعة.</li>
        <li>إمكانية تحميل الصور بجودتها الأصلية للطباعة.</li>
        <li>رسائل وداعية وتهاني صوتية من زمايلك.</li>
      </ul>
    </div>
  </PageLayout>
);

export const PrivacyPage = () => (
  <PageLayout title="سياسة الخصوصية" subtitle="خصوصية بياناتك وصورك هي أولويتنا">
    <div className="arabic-leading text-on-surface-variant fs-6">
      <p>في يومك، نحن نلتزم بحماية خصوصيتك وبياناتك الشخصية وصورك. هذه السياسة توضح كيف نتعامل مع المعلومات التي نجمعها.</p>
      <h4 className="fw-bold text-primary mt-4">1. جمع المعلومات</h4>
      <p>نجمع المعلومات الضرورية فقط لإنشاء حسابك وإدارة مناسبتك، مثل الاسم والبريد الإلكتروني ورقم الهاتف.</p>
      <h4 className="fw-bold text-primary mt-4">2. الصور والمحتوى</h4>
      <p>الصور والمحتوى الذي يتم رفعه يخص صاحب المناسبة فقط، ولا يحق لأي طرف ثالث الوصول إليها دون إذن.</p>
      <h4 className="fw-bold text-primary mt-4">3. أمان البيانات</h4>
      <p>نستخدم أحدث تقنيات التشفير لضمان أمان بياناتك وصورك على خوادمنا.</p>
    </div>
  </PageLayout>
);

export const TermsPage = () => (
  <PageLayout title="الشروط والأحكام" subtitle="قواعد استخدام منصة يومك">
    <div className="arabic-leading text-on-surface-variant fs-6">
      <p>باستخدامك لمنصة يومك، فإنك توافق على الالتزام بالشروط والأحكام التالية.</p>
      <h4 className="fw-bold text-primary mt-4">1. شروط الاستخدام</h4>
      <p>يجب استخدام المنصة في الأغراض المخصصة لها فقط (توثيق المناسبات الاجتماعية السعيدة).</p>
      <h4 className="fw-bold text-primary mt-4">2. المحتوى المرفوع</h4>
      <p>يتحمل صاحب المناسبة المسؤولية الكاملة عن المحتوى الذي يتم رفعه أو مشاركته عبر الرابط الخاص به.</p>
      <h4 className="fw-bold text-primary mt-4">3. حقوق الملكية</h4>
      <p>جميع حقوق العلامة التجارية والتصميمات الخاصة بالمنصة مملوكة لـ يومك.</p>
    </div>
  </PageLayout>
);

export const ContactPage = () => (
  <PageLayout title="اتصل بنا" subtitle="فريقنا دايماً في خدمتك">
    <div className="arabic-leading text-on-surface-variant fs-5 text-center py-4">
      <p className="mb-4">عندك استفسار أو محتاج مساعدة في تنظيم مناسبتك؟ تواصل معانا فوراً.</p>
      <div className="d-flex flex-column gap-3 align-items-center">
        <div className="bg-surface-variant p-4 rounded-celebration border border-primary-dim w-100 maxWidth-600">
           <h4 className="fw-black text-primary mb-3">بيانات التواصل</h4>
           <p className="mb-2">📞 واتساب / اتصال: <strong>01013201998</strong></p>
           <p className="mb-2">📧 بريد إلكتروني: <strong>youmak.egp@gmail.com</strong></p>
           <p className="mb-0">📍 العنوان: القاهرة، مصر.</p>
        </div>
      </div>
    </div>
  </PageLayout>
);

export const AboutPage = () => (
  <PageLayout title="عن الشركة" subtitle="يومك.. رؤية جديدة لتوثيق اللحظات السعيدة">
    <div className="arabic-leading text-on-surface-variant fs-5">
      <p>يومك هي منصة مصرية رائدة متخصصة في توثيق المناسبات الاجتماعية باستخدام أحدث تقنيات المشاركة الفورية.</p>
      <h3 className="fw-black text-primary mt-4 mb-3">رؤيتنا:</h3>
      <p>نهدف إلى تحويل كل مناسبة اجتماعية إلى ذكرى حية ومستمرة، من خلال تمكين الضيوف من المشاركة الفعالة في صناعة ألبوم الصور والفيديوهات بلمسة واحدة.</p>
      <h3 className="fw-black text-primary mt-4 mb-3">قيمنا:</h3>
      <ul>
        <li><strong>الخصوصية:</strong> صورك وبياناتك في أمان تام.</li>
        <li><strong>الجودة:</strong> نحافظ على أعلى جودة للمحتوى المرفوع.</li>
        <li><strong>السهولة:</strong> تجربة مستخدم بسيطة وممتعة للجميع.</li>
      </ul>
    </div>
  </PageLayout>
);
